"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var info = {
  $schema: '../assetlist.schema.json',
  chain_name: 'polkadot',
  assets: [{
    description: 'The native fee, governance, staking, and bonding token of the Polkadot platform.',
    denom_units: [{
      denom: 'Planck',
      exponent: 0,
      aliases: ['planck']
    }, {
      denom: 'uDOT',
      exponent: 4,
      aliases: ['udot', 'microdot', 'Microdot']
    }, {
      denom: 'mDOT',
      exponent: 7,
      aliases: ['millidot', 'Millidot']
    }, {
      denom: 'DOT',
      exponent: 10,
      aliases: ['dot', 'New DOT', 'new dot']
    }, {
      denom: 'DOT (old)',
      exponent: 12
    }, {
      denom: 'MDOT',
      exponent: 16,
      aliases: ['million', 'Million']
    }],
    base: 'Planck',
    name: 'Polkadot',
    display: 'DOT',
    symbol: 'DOT',
    logo_URIs: {
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg'
    },
    coingecko_id: 'polkadot',
    images: [{
      svg: 'https://raw.githubusercontent.com/cosmos/chain-registry/master/_non-cosmos/polkadot/images/dot.svg'
    }]
  }]
};
var _default = exports["default"] = info;